import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./leftmenu.css";
import { Link, NavLink } from "react-router-dom";

const Leftmenu = ({ logout, user }) => {

    return (
        <>
            <div className="leftmenu">
                <div className="leftmenu-flex">
                    <div className="leftmenu-flex-box1">
                        <div className="leftmenu-logo">
                            <img src="/logoleftmenu.png" alt="" />
                        </div>
                    </div>
                    <div className="leftmenu-flex-box2" title={`${user?.role} + ${(user?.subroles || []).join(", ")}`}>
                        <div className="leftmenu-logo-user">
                            {(user?.fullname || "").trim().slice(0, 2).toUpperCase()}
                        </div>
                        <div className="leftmenu-fullname-user">
                            {user?.fullname}
                        </div>
                    </div>
                    <div className="leftmenu-flex-box3">
                        <NavLink className="link leftmenubtn" to={"/home"} >
                            <span>
                                <i class="fa-regular fa-calendar"></i>
                            </span>
                            <h4>
                                Календарь
                            </h4>
                        </NavLink>
                        {
                            (user?.role === "admin") && (
                                <NavLink className="link leftmenubtn" to="/orders">
                                    <span>
                                        <i class="fa-solid fa-list"></i>
                                    </span>
                                    <h4>Все заказы</h4>
                                </NavLink>
                            )
                        }
                        {
                            (user?.role === "admin" || user?.role === "operator") && (
                                <NavLink className="link leftmenubtn" to="/myorders">
                                    <span>
                                        <i class="fa-solid fa-check-to-slot"></i>
                                    </span>
                                    <h4>Мои заказы</h4>
                                </NavLink>
                            )
                        }
                        {
                            (user?.role === "admin" || user?.role === "mechanic" || user?.subroles?.includes("addCompanyandtours") || user?.subroles?.includes("bus") || user?.subroles?.includes("lunch") || user?.subroles?.includes("sedan") || user?.subroles?.includes("guide") || user?.subroles?.includes("guide") ) && (
                                <NavLink className="link leftmenubtn" to="/performers">
                                    <span>
                                        <i class="fa-solid fa-arrow-pointer"></i>
                                    </span>
                                    <h4>Исполнители</h4>
                                </NavLink>
                            )
                        }
                        {
                            (user?.role === "admin" || user?.role === "operator") && (
                                <NavLink className="link leftmenubtn" to="/yurtcump">
                                    <span>
                                        <i class="fa-solid fa-baseball"></i>
                                    </span>
                                    <h4>Юрта</h4>
                                </NavLink>
                            )
                        }
                        {
                            (user?.role === "admin" || user?.role === "operator") && (
                                <NavLink className="link leftmenubtn" to="/guesthouse">
                                    <span>
                                        <i class="fa-solid fa-hotel"></i>
                                    </span>
                                    <h4>Гостевой дом</h4>
                                </NavLink>
                            )
                        }
                        {/* {
                            (user?.role === "admin" || user?.subroles?.includes("sedan")) && (
                                <NavLink className="link leftmenubtn" to="/sedan">
                                    <span>
                                        <i className="fa-solid fa-car"></i>
                                    </span>
                                    <h4>Седан</h4>
                                </NavLink>
                            )
                        }
                        {
                            (user?.role === "admin" || user?.subroles?.includes("minibus")) && (
                                <NavLink className="link leftmenubtn" to="/minibus">
                                    <span>
                                        <i class="fa-solid fa-van-shuttle"></i>
                                    </span>
                                    <h4>Микро/Автобус</h4>
                                </NavLink>
                            )
                        } */}
                        {
                            (user?.role === "admin" || user?.subroles?.includes("addCompanyandtours")) && (
                                <NavLink className="link leftmenubtn" to="/addresurs">
                                    <span>
                                        <i class="fa-solid fa-bars"></i>
                                    </span>
                                    <h4>Ресурсы</h4>
                                </NavLink>
                            )
                        }

                    </div>
                </div>

                <div className="leftmenu-logout">
                    <button onClick={logout} title="Выйти">
                        <i className="fas fa-sign-out-alt"></i>
                        <span>Выйти</span>
                    </button>
                </div>
            </div>


        </>
    );
};
export default Leftmenu;
